// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as LlIcon from "../components/LlIcon.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ProfileIcon from "../components/ProfileIcon.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as PlayerBookmark from "../player/PlayerBookmark.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import Tooltip from "@mui/material/Tooltip";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";
import Bookmark from "@mui/icons-material/Bookmark";

function PlBanner$ProfileIcon(Props) {
  var playerInfo = Props.playerInfo;
  var tier = Props.tier;
  var companionId = Props.companionId;
  var basePath4 = CdnAtom.usePath4(undefined);
  var gmp;
  switch (tier) {
    case "challenger" :
    case "grandmaster" :
        gmp = true;
        break;
    default:
      gmp = false;
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "pointer-events-none rounded-full absolute " + (
                    gmp ? "left-[64px] top-[96px]" : "left-[61px] top-[92px]"
                  )
                }, React.createElement(ProfileIcon.make, {
                      id: playerInfo.profileIconId,
                      size: gmp ? 73 : 78
                    })), React.createElement("div", {
                  className: "pointer-events-none absolute " + (
                    gmp ? "min-w-[186px] left-[8px] top-[5px]" : "min-w-[200px] left-[0px] top-[-7px]"
                  )
                }, React.createElement("img", {
                      alt: tier,
                      src: basePath4 + "/banner/wings2_" + tier + ".png?w=" + (
                        gmp ? "186" : "200"
                      ),
                      width: gmp ? "186" : "200"
                    })), React.createElement("div", {
                  className: "absolute top-[140px] left-[112px] w-[52px] h-[52px]"
                }, React.createElement(LlIcon.make, {
                      companionId: companionId,
                      size: 52
                    })), React.createElement("div", {
                  className: "pointer-events-none absolute w-[86px] left-[95px] top-[127px]"
                }, React.createElement("img", {
                      alt: tier,
                      height: "86",
                      src: basePath4 + "/banner/" + tier + "_base3.png?w=86",
                      width: "86"
                    })));
}

var ProfileIcon$1 = {
  make: PlBanner$ProfileIcon
};

function PlBanner(Props) {
  var matches = Props.matches;
  var playerCompanionId = Props.playerCompanionId;
  var playerInfo = Props.playerInfo;
  var topRank = Props.topRank;
  var league = Props.league;
  var localRank = Props.localRank;
  var globalRank = Props.globalRank;
  var hidePctRanks = Props.hidePctRanks;
  var basePath4 = CdnAtom.usePath4(undefined);
  var match = PlayerBookmark.use(undefined);
  var setFavorites = match[1];
  var favorited = Belt_Array.some(match[0], (function (f) {
          if (f.region === playerInfo.region) {
            return f.name === playerInfo.name;
          } else {
            return false;
          }
        }));
  var tier;
  if (league !== undefined) {
    var league$1 = league[1];
    switch (league$1) {
      case "BLUE" :
          tier = "diamond";
          break;
      case "GRAY" :
          tier = "silver";
          break;
      case "GREEN" :
          tier = "platinum";
          break;
      case "ORANGE" :
          tier = "grandmaster";
          break;
      case "PURPLE" :
          tier = "master";
          break;
      default:
        tier = Belt_Array.getExn(league$1.split(" "), 0).toLowerCase();
    }
  } else {
    tier = "iron";
  }
  var bgTier;
  if (league !== undefined) {
    var league$2 = league[1];
    switch (league$2) {
      case "BLUE" :
          bgTier = "diamond";
          break;
      case "GRAY" :
          bgTier = "silver";
          break;
      case "GREEN" :
          bgTier = "platinum";
          break;
      case "ORANGE" :
          bgTier = "grandmaster";
          break;
      case "PURPLE" :
          bgTier = "master";
          break;
      default:
        bgTier = Belt_Array.getExn(league$2.split(" "), 0).toLowerCase();
    }
  } else {
    bgTier = "default";
  }
  var unitFreqs = Belt_MutableMapString.make(undefined);
  Belt_Array.forEach(matches, (function (hp) {
          return Belt_Array.forEach(hp.info.units, (function (unit) {
                        var group = Belt_MutableMapString.getWithDefault(unitFreqs, unit.id, []);
                        group.push(unit.items.length);
                        return Belt_MutableMapString.set(unitFreqs, unit.id, group);
                      }));
        }));
  var match$1 = T.isNonLatinName(playerInfo.name);
  var match$2 = playerInfo.name.length;
  var tmp;
  if (localRank !== undefined && globalRank !== undefined && !hidePctRanks) {
    var localNum = localRank[0] + 1 | 0;
    var localPct = Caml.caml_float_max(localRank[1], 0.00001);
    tmp = React.createElement("div", {
          className: "leading-normal"
        }, React.createElement("div", undefined, Region.toName3(Region.fromApiName(playerInfo.region)) + " #" + localNum.toLocaleString()), React.createElement("div", undefined, "Top " + Global.formatPct(localPct < 0.001 ? 2 : 1, localPct) + "%"), React.createElement("div", {
              className: "pt-1"
            }, "Global #" + (globalRank[0] + 1 | 0).toLocaleString()), topRank !== undefined ? React.createElement("div", {
                className: "pt-1"
              }, "Peak rank: " + LpChartUtils.divisionToShortName(topRank[1]) + " " + String(topRank[2]) + "LP") : null);
  } else {
    tmp = null;
  }
  var tmp$1;
  if (localRank !== undefined && (!hidePctRanks || localRank[0] < 100)) {
    var localPct$1 = Caml.caml_float_max(localRank[1], 0.00001);
    var localNum$1 = localRank[0] + 1 | 0;
    tmp$1 = React.createElement("div", {
          className: "font-medium pt-[2px] text-[14px]"
        }, (
          localNum$1 < 1000 ? "#" + String(localNum$1) + " " : "Top " + Global.formatPct(localPct$1 < 0.001 ? 2 : 1, localPct$1) + "% "
        ) + Region.toName3(Region.fromApiName(playerInfo.region)));
  } else {
    tmp$1 = null;
  }
  return React.createElement("div", {
              className: "min-w-[200px] relative flex flex-col items-center overflow-hidden"
            }, React.createElement("div", {
                  className: "cursor-pointer absolute top-[10px] left-[10px] z-10 " + (
                    favorited ? "text-legendary-3" : "text-white2"
                  ),
                  onClick: (function (param) {
                      return Curry._1(setFavorites, (function (favorites) {
                                    if (favorited) {
                                      var cb = SnackbarService.sub.contents;
                                      if (cb !== undefined) {
                                        Curry._1(cb, playerInfo.name + " removed from bookmarks");
                                      }
                                      return Belt_Array.keep(favorites, (function (f) {
                                                    return !(f.region === playerInfo.region && f.name === playerInfo.name);
                                                  }));
                                    }
                                    var cb$1 = SnackbarService.sub.contents;
                                    if (cb$1 !== undefined) {
                                      Curry._1(cb$1, playerInfo.name + " added to bookmarks");
                                    }
                                    return Belt_Array.concat(favorites, [{
                                                  region: playerInfo.region,
                                                  name: playerInfo.name,
                                                  puuid: playerInfo.puuid,
                                                  tag: playerInfo.tag,
                                                  littleLegend: playerCompanionId,
                                                  tier: tier
                                                }]);
                                  }));
                    })
                }, React.createElement(Bookmark, {
                      color: "inherit"
                    })), React.createElement("div", {
                  className: "ml-[-50px] mr-[-50px] mt-[-342px]"
                }, React.createElement("img", {
                      className: "pointer-events-none",
                      height: "725",
                      src: basePath4 + "/banner/bg2_" + bgTier + ".png?w=225",
                      width: "225"
                    })), React.createElement(PlBanner$ProfileIcon, {
                  playerInfo: playerInfo,
                  tier: tier,
                  companionId: playerCompanionId
                }), React.createElement("div", {
                  className: "font-montserrat flex flex-col items-center absolute mx-auto top-[220px]"
                }, React.createElement("div", {
                      className: CssJs.merge([
                            "notranslate font-semibold text-center mt-1 max-w-[200px]",
                            CssJs.style([
                                  CssJs.lineHeight({
                                        NAME: "abs",
                                        VAL: 1.1
                                      }),
                                  CssJs.unsafe("wordBreak", "break-word")
                                ]),
                            match$1 ? (
                                match$2 < 9 ? "text-2xl" : (
                                    match$2 < 12 ? "text-xl" : "text-lg"
                                  )
                              ) : (
                                match$2 < 11 ? "text-2xl" : (
                                    match$2 < 15 ? "text-xl" : "text-lg"
                                  )
                              )
                          ])
                    }, playerInfo.name), React.createElement(Tooltip, {
                      title: tmp,
                      children: React.createElement("div", {
                            className: "flex flex-col items-center text-base leading-normal"
                          }, React.createElement("div", {
                                className: "mt-[6px] font-semibold"
                              }, league !== undefined ? LpChartUtils.renderDivisionName(league[1]) + " " + (String(league[2]) + "LP") : "Unranked"), tmp$1)
                    })));
}

var make = PlBanner;

export {
  ProfileIcon$1 as ProfileIcon,
  make ,
  
}
/* T Not a pure module */
